// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const labPaths = {
    list:   ()    => 'admin/labs',
    detail: (id)  => `admin/labs/${id}`,
};
